import type {
	LoanDetailDataDTO,
	PortfolioDetailResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { mapCoDebtorsToForm } from "web_myplann/Portfolio/Forms/CoDebtors/mapCoDebtorsToForm";
import { parseIsoDate } from "web_myplann/Portfolio/Forms/dateParsers";
import { LOANS_FORM_DEFAULT_VALUES as DEFAULTS } from "web_myplann/Portfolio/Forms/LoansForm/loansFormDefaults";
import type { LoansFormInput } from "web_myplann/Portfolio/Forms/LoansForm/loansFormSchema";
import { toLoanPaymentFrequency } from "web_myplann/Portfolio/Helpers/loanPaymentFrequencies";

export const mapPortfolioToLoansForm = (
	portfolio: PortfolioDetailResponseDTO,
): LoansFormInput => {
	const data = portfolio.data as LoanDetailDataDTO | undefined;

	return {
		name: portfolio.name ?? DEFAULTS.name,
		contractNumber: portfolio.contractNumber ?? DEFAULTS.contractNumber,
		producer: portfolio.producer ?? DEFAULTS.producer,
		product: portfolio.product ?? DEFAULTS.product,
		signedAt: parseIsoDate(portfolio.signedAt),
		startAt: parseIsoDate(portfolio.startAt),
		endAt: parseIsoDate(portfolio.endAt),
		value: null,
		coDebtors: mapCoDebtorsToForm(data?.coDebtors),
		change: {
			originalObligationAmount:
				data?.originalObligationAmount ??
				DEFAULTS.change.originalObligationAmount,
			installment: data?.installment ?? DEFAULTS.change.installment,
			interestRate: data?.interestRate ?? DEFAULTS.change.interestRate,
			fixationEndDate: parseIsoDate(data?.fixationEndDate),
			paymentFrequency: toLoanPaymentFrequency(data?.paymentFrequency),
		},
	};
};
